module.exports = __webpack_public_path__ + "img/default-product.593ae091.png";